import React, { PureComponent } from 'react'
import { func, bool } from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import { noop } from '../../../../shared/utils/commonUtils'
import CountryContent from '../../../common/CountryContent'

class CountryChoose extends PureComponent {
  static propTypes = {
    handleChangeCountry: func.isRequired,
    isCountryChooseShow: bool.isRequired,
    isForceRequireAction: bool,
    handleCountryChooseModalClose: func.isRequired,
    handleCountryChooseSubmit: func.isRequired,
  }

  static defaultProps = {
    isForceRequireAction: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      resetHandler: noop,
    }
  }

  onClose = () => {
    const { isForceRequireAction, handleCountryChooseModalClose } = this.props
    if (!isForceRequireAction) {
      const { resetHandler } = this.state
      resetHandler()
      handleCountryChooseModalClose()
    }
  }

  initResetHandler = resetHandler => {
    this.setState({ resetHandler })
  }

  render() {
    const {
      isCountryChooseShow, handleChangeCountry, handleCountryChooseSubmit,
    } = this.props

    return (
      <Modal
        autoFocusClose
        shown={isCountryChooseShow}
        onClose={this.onClose}
        className="passport-ui-app__modal passport__country-selector action_required"
        size="md"
      >
        <CountryContent
          handleCountryContentSubmit={handleCountryChooseSubmit}
          handleChangeCountry={handleChangeCountry}
          initResetHandler={this.initResetHandler}
          Body={ModalBody}
          Footer={ModalFooter}
        />
      </Modal>

    )
  }
}

export default CountryChoose
